import React from 'react'

import ImportsHome from "containers/ImportsHome";

const CSVImportLogs = () => {
  return (
    <ImportsHome />
  )
}

export default CSVImportLogs